export default {
      id: "logo-usage",
      viewBox: "0 0 310 70",
      url: "../dist/images/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }